export enum EnergyTypeEnum {
    "HeatHighGrey" = "Hoge Temperatuur, Grijs",
    "HeatHighRenewable" = "Hoge Temperatuur, Hernieuwbaar",
    "HeatLowGrey" = "Lage Temperatuur, Grijs",
    "HeatLowRenewable" = "Lage Temperatuur, Hernieuwbaar",
    "No"="Geen"
}